import { ScheduleSideDrawer } from '@/components/calendar/ScheduleSideDrawer'
import { WalkinQueuePanel } from '@/components/calendar/WalkinQueuePanel'

/**
 * @param {{
 *   open: boolean
 *   onClose: () => void
 *   stylists: import('@/types/api').Stylist[]
 *   entries: import('@/types/api').WalkinQueueEntry[]
 *   onEntriesChange: (entries: import('@/types/api').WalkinQueueEntry[]) => void
 *   services: import('@/types/api').Service[]
 *   queueLoading?: boolean
 *   onRefreshQueue?: () => Promise<void>
 * }} props
 */
export function WalkInDrawer({
  open,
  onClose,
  stylists,
  entries,
  onEntriesChange,
  services,
  queueLoading = false,
  onRefreshQueue,
}) {
  const waiting = entries.filter((entry) => entry.status === 'waiting').length

  return (
    <ScheduleSideDrawer
      open={open}
      onClose={onClose}
      title="Walk-in queue"
      subtitle={waiting === 1 ? '1 guest waiting' : `${waiting} guests waiting`}
      widthClassName="w-full max-w-[26rem]"
    >
      <div className="-mx-5 -my-4">
        <WalkinQueuePanel
          embedded
          stylists={stylists}
          entries={entries}
          onEntriesChange={onEntriesChange}
          services={services}
          queueLoading={queueLoading}
          onRefreshQueue={onRefreshQueue}
        />
      </div>
    </ScheduleSideDrawer>
  )
}
